
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowColour as ObiLightningLightSnowColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-colour.js';
 
 
 

 
 export const ObiLightningLightSnowColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-colour',
   elementClass: ObiLightningLightSnowColourElement,
   events: {
     
   }
  });
 
 